import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'

// rsuite
import Table from 'rsuite/Table'
import Tag from 'rsuite/Tag'
import Toggle from 'rsuite/Toggle'
import Tooltip from 'rsuite/Tooltip'
import Whisper from 'rsuite/Whisper'

// includes
import Edit2 from '@rsuite/icons/Edit'
import TrashIcon from '@rsuite/icons/Trash'
import {isEmpty} from 'lodash'
import {toast} from 'react-toastify'
import {SortType} from 'rsuite-table/lib/@types/common'
import Pagination from 'rsuite/Pagination'
import IconButton from 'rsuite/esm/IconButton'
import {ItemType, StateParamsModel} from 'src/app/modules/common/Model'
import CheckPermissions from 'src/app/modules/common/checkPermission'
import DeleteModal from 'src/app/modules/common/components/deleteModal'
import DesignComponent from 'src/app/modules/common/components/designComponent'
import RSuiteTable from 'src/cms/helpers/components/rsuiteTable'
import * as websiteSectionRedux from '../index'
import AddWebsiteSection from './AddWebsiteSection'

const WebsiteSectionComponent = () => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [actionType, setActionType] = useState('Add')
  const {
    data,
    loading,
    singleEnableSuccess,
    singleDisableSuccess,
    enableSuccess,
    disableSuccess,
    toggleLoading,
    success,
    deleteSuccess,
    sortWebsiteSectionData,
  } = useSelector((state: any) => state.websiteSection)
  const [params, setParams] = useState<StateParamsModel>({
    page: 1,
    limit: 10,
  })
  const [checkedValues, setCheckedValues] = useState<Array<string>>([])
  const [editSelectedData, setEditCheckedData] = useState<any>()

  // alert modal
  const [alertOpen, setAlertOpen] = useState(false)
  const handleAlertOpen = () => setAlertOpen(true)
  const handleAlertClose = () => setAlertOpen(false)
  const [openSortModal, setOpenSortModal] = useState(false)

  const handleChangeLimit = (dataKey: number) => {
    setParams({
      ...params,
      limit: dataKey,
    })
  }

  const enableWebsiteSectionData = () => {
    if (!isEmpty(checkedValues)) {
      const formData = checkedValues.map((d: string) => ({
        id: d,
      }))
      dispatch(websiteSectionRedux.actions.enableWebsiteSection(formData))
    } else {
      toast.error('No data Selected')
    }
  }

  const disableWebsiteSectionData = () => {
    if (!isEmpty(checkedValues)) {
      const formData = checkedValues.map((d: string) => ({
        id: d,
      }))
      dispatch(websiteSectionRedux.actions.disableWebsiteSection(formData))
    } else {
      toast.error('No data Selected')
    }
  }

  const ActionCell = ({rowData, dataKey, ...props}: any) => {
    function handleAction() {
      alert(`id:${rowData[dataKey]}`)
    }
    return (
      <Cell {...props} className='link-group' data-cy='algolia-search-link-group'>
        <CheckPermissions type='Edit'>
          <Whisper
            placement='top'
            trigger='hover'
            data-cy='algolia-search-edit-button'
            speaker={<Tooltip>Edit</Tooltip>}
          >
            <IconButton
              appearance='subtle'
              onClick={() => {
                setEditCheckedData(rowData)
                setActionType('Edit')
                setOpen(true)
              }}
              icon={<Edit2 />}
              data-cy='edit-button'
            />
          </Whisper>
        </CheckPermissions>
        <CheckPermissions type='Delete'>
          <Whisper
            placement='top'
            trigger='hover'
            data-cy='algolia-search-delete-button'
            speaker={<Tooltip>Delete</Tooltip>}
          >
            <IconButton
              appearance='subtle'
              onClick={() => {
                handleAlertOpen()
                let websiteSectionId = [rowData.id]
                setCheckedValues(websiteSectionId)
              }}
              icon={<TrashIcon />}
              data-cy='delete-button'
            />
          </Whisper>
        </CheckPermissions>
        <Whisper
          placement='top'
          trigger='hover'
          data-cy='algolia-search-status-button'
          speaker={<Tooltip>Status</Tooltip>}
        >
          <Toggle
            size='sm'
            disabled={toggleLoading}
            checked={rowData.status}
            onClick={() => handleToggleAction(rowData)}
            data-cy='toggle-button'
          />
        </Whisper>
      </Cell>
    )
  }

  const handleToggleAction = (data: {[key: string]: string}) => {
    data?.status
      ? dispatch(websiteSectionRedux.actions.singleDisableWebsiteSection({id: data.id}))
      : dispatch(websiteSectionRedux.actions.singleEnableWebsiteSection({id: data.id}))
  }

  const Cell = Table.Cell

  const handleClose = () => setOpen(false)

  const columns = [
    {
      label: 'S.N.',
      dataKey: 'sn',
      width: 60,
      cell: <Cell dataKey='sn' />,
    },
    {
      label: 'Title',
      dataKey: 'title',
      flexGrow: 1,
      cell: <Cell dataKey='title' />,
      sortable: true,
    },
    {
      label: 'Website Block',
      dataKey: 'websiteBlockItemName',
      flexGrow: 1,
      cell: <Cell dataKey='websiteBlockItemName' />,
      sortable: false,
    },
    {
      label: 'Link',
      dataKey: 'link',
      flexGrow: 1,
      cell: <Cell dataKey='link' />,
      sortable: false,
    },
    {
      label: 'Order',
      dataKey: 'order',
      height: 85,
      cell: <Cell dataKey='order' />,
      sortable: true,
    },

    {
      label: 'Status',
      dataKey: 'status',
      width: 85,
      cell: (
        <Cell>
          {(rowData) =>
            rowData?.status ? (
              <Tag color='green' size='sm'>
                Active
              </Tag>
            ) : (
              <Tag color='red' size='sm'>
                Inactive
              </Tag>
            )
          }
        </Cell>
      ),
      sortable: false,
    },
    {
      label: 'Action',
      width: 150,
      align: 'center',
      cell: <ActionCell dataKey='id' />,
    },
  ]

  useEffect(() => {
    dispatch(websiteSectionRedux.actions.getWebsiteSection(params))
  }, [params])

  const handleChecked = (values: Array<string>) => {
    setCheckedValues(values)
  }

  useEffect(() => {
    if (deleteSuccess) {
      toast.success('Website Section deleted successfully')
    }
    if (enableSuccess) {
      toast.success('Website Section enabled successfully')
    }
    if (disableSuccess) {
      toast.success('Website Section disabled successfully')
    }
    handleChecked([])
    dispatch(websiteSectionRedux?.actions.getWebsiteSection(params))
  }, [deleteSuccess, success, enableSuccess, disableSuccess])

  useEffect(() => {
    if (singleEnableSuccess) {
      toast.success('Website Section enabled successfully')
      dispatch(websiteSectionRedux.actions.getWebsiteSection(params))
    }
    if (singleDisableSuccess) {
      toast.success('Website Section disabled successfully')
      dispatch(websiteSectionRedux.actions.getWebsiteSection(params))
    }
    handleChecked([])
  }, [singleDisableSuccess, singleEnableSuccess])

  const websiteSectionData = data?.websiteSection
    ? data?.websiteSection?.map((item: any, i: number) => ({
        sn: (params?.page - 1) * params?.limit + (i + 1),
        id: item?.id,
        title: item?.title,
        titleNp: item?.titleNp,
        subtitle: item?.subtitle,
        subtitleNp: item?.subtitleNp,
        link: item?.link,
        image: item?.image,
        description: item?.description,
        descriptionNp: item?.descriptionNp,
        ctaButtonOne: item?.ctaButtonOne,
        ctaButtonOneLink: item?.ctaButtonOneLink,
        ctaButtonTwo: item?.ctaButtonTwo,
        ctaButtonTwoLink: item?.ctaButtonTwoLink,
        websiteBlockItemId: item?.websiteBlockItem?.id,
        websiteBlockItemName: item?.websiteBlockItem?.title,
        showInHomepage: item?.showInHomePage,
        status: item?.status,
        order: item?.order,
      }))
    : []

  const handleSort = (dataKey: string, sortType?: SortType) => {
    setParams({...params, orderBy: dataKey, order: sortType})
  }

  const handleAddModal = () => {
    setEditCheckedData({})
    setOpen(true)
    setActionType('Add')
  }

  const handleDelete = () => {
    let websiteSectionId = checkedValues?.map((value) => ({id: value}))
    dispatch(websiteSectionRedux?.actions?.deleteWebsiteSection(websiteSectionId))
    handleAlertClose()
  }

  const handleRefresh = () => {
    dispatch(websiteSectionRedux.actions.getWebsiteSection(params))
  }

  const handleGetAllData = () => {
    setParams({...params, limit: data?.meta?.total})
    dispatch(websiteSectionRedux.actions.getWebsiteSection(params))
  }

  const handleSubmitSort = (data: Array<ItemType>) => {
    let body = {
      websiteSectionId: data?.map((item) => ({id: item?.keyId})),
    }
    dispatch(websiteSectionRedux.actions.sortWebsiteSection(body))
  }

  useEffect(() => {
    if (!isEmpty(sortWebsiteSectionData) && success) {
      toast.success('Website Section sorted successfully')
      dispatch(websiteSectionRedux.actions.sortWebsiteSectionReset())
      setParams({...params, limit: 10})
      dispatch(websiteSectionRedux.actions.getWebsiteSection(params))
      setOpenSortModal(false)
    }
  }, [sortWebsiteSectionData, success])

  return (
    <>
      <div className='shadow p-3 bg-white rounded' data-cy='algolia-search-shadow-comp'>
        <DesignComponent
          moduleName='Website Section'
          params={params}
          setParams={setParams}
          handleRefresh={handleRefresh}
          handleAddModal={handleAddModal}
          handleAlertOpen={handleAlertOpen}
          exportShow={false}
          importShow={false}
          enableMultiple={enableWebsiteSectionData}
          disableMultiple={disableWebsiteSectionData}
          data={websiteSectionData}
          sortShow={true}
          sortButtonName='Sort'
          handleSubmitSort={handleSubmitSort}
          handleGetAllData={handleGetAllData}
          openSortModal={openSortModal}
          setOpenSortModal={setOpenSortModal}
          loading={loading}
          data-cy='algolia-search-design-comp'
        />

        <div className='datatable' data-cy='algolia-search-datatable'>
          <RSuiteTable
            onChecked={handleChecked}
            showCheckbox={true}
            columns={columns}
            data={websiteSectionData}
            checkedValues={checkedValues}
            showLoading={loading}
            handleSort={handleSort}
            data-cy='algolia-search-r-suite'
          />
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            className='mt-5'
            maxButtons={5}
            size='sm'
            layout={['total', '-', 'limit', '|', 'pager', 'skip']}
            total={data?.meta?.total || 0}
            limitOptions={[10, 20, 50, 100]}
            limit={params?.limit}
            activePage={params?.page}
            onChangePage={(value) => setParams({...params, page: value})}
            onChangeLimit={handleChangeLimit}
            data-cy='algolia-search-pagination'
          />
          {open && (
            <AddWebsiteSection
              open={open}
              params={params}
              handleClose={handleClose}
              actionType={actionType}
              editSelectedData={editSelectedData}
            />
          )}
        </div>

        {/* Delete Modal */}
        {alertOpen &&
          (!isEmpty(checkedValues) ? (
            <DeleteModal
              handleClick={() => handleDelete()}
              isOpen={alertOpen}
              handleClose={() => handleAlertClose()}
            />
          ) : (
            toast.error('No data selected') && setAlertOpen(false)
          ))}
      </div>
    </>
  )
}

export default WebsiteSectionComponent
